import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Chip,
  Card,
  useTheme,
  Fade,
  Grow,
  Slide,
  Zoom,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  Category as CategoryIcon,
} from "@mui/icons-material";
import useAxios from "../useAxios";
import BlockIcon from '@mui/icons-material/Block';
import {
  ArrowBack,
} from "@mui/icons-material";
import ProductDetailView from "./UserProductDel";
import { keyframes } from "@emotion/react";
// import ModernLoader from "./ModernLoder";
import ModernLoder, {
  CategoryDetailsLoader,
  RegistrationIdeasLoader,
  ProductCategoriesLoader,
} from "./ModernLoder";
import { Search as SearchIcon } from "@mui/icons-material";
const pulseAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.03); }
  100% { transform: scale(1); }
`;

const floatAnimation = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-8px); }
  100% { transform: translateY(0px); }
`;

const ProductCategories = ({ onBack, selectedCategoryGet  }) => {
  const theme = useTheme();
  const axiosData = useAxios();
  const [ideas, setIdeas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedIdea, setSelectedIdea] = useState(null);
  const [cityStatus, setCityStatus] = useState("");
  const [userDetails, setUserDetails] = useState();
  const [selectedCity, setSelectedCity] = useState("");
  // const [colors, setColors] = useState([
  //   "#4e79a7",
  //   "#f28e2b",
  //   "#e15759",
  //   "#76b7b2",
  //   "#59a14f",
  //   "#edc948",
  //   "#b07aa1",
  //   "#ff9da7",
  //   "#9c755f",
  //   "#bab0ab",
  //   "#4b6c9c",
  //   "#c44e52",
  //   "#8dd3c7",
  //   "#fddaec",
  //   "#b3de69",
  // ]);
  const [colors, setColors] = useState([
    "#3e5f87", // darkened #4e79a7
    "#c5721f", // darkened #f28e2b
    "#b04042", // darkened #e15759
    "#5b9590", // darkened #76b7b2
    "#4a813f", // darkened #59a14f
    "#c4a431", // darkened #edc948
    "#905a8a", // darkened #b07aa1
    "#cc7e88", // darkened #ff9da7
    "#7d5e4d", // darkened #9c755f
    "#98918d", // darkened #bab0ab
    "#3a557d", // darkened #4b6c9c
    "#a23e43", // darkened #c44e52
    "#70b1a9", // darkened #8dd3c7
    "#f0bad4", // darkened #fddaec
    "#8fb755", // darkened #b3de69
  ]);
  const [gradientColors] = useState([
    "linear-gradient(135deg, #f73030ff 0%, #9c1c1cff 100%)",
    // "linear-gradient(135deg, #4b5dbd 0%, #5a3e87 100%)", // darkened blue-purple
    // "linear-gradient(135deg, #d177d8 0%, #cc435a 100%)", // darkened pink-red
    // "linear-gradient(135deg, #42b6aa 0%, #9472aa 100%)", // darkened teal-purple
    // "linear-gradient(135deg, #aab1c2 0%, #aab1c2 100%)", // darker neutral
    // "linear-gradient(135deg, #7ca5e0 0%, #a0c8e5 100%)", // darkened blue
    // "linear-gradient(135deg, #e18085 0%, #e8b1b6 100%)", // darkened peach-pink
    // "linear-gradient(135deg, #e6d0b6 0%, #db9674 100%)", // darkened warm beige
  ]);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchTermProduct, setSearchTermProduct] = useState("");
  const [filteredProdctCat, setFilteredProdctCat] = useState([]);
  const [filteredProdct, setFilteredProdct] = useState([]);
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [newIdea, setNewIdea] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const handleSearch = () => {
    const searchValue = searchTerm.toLowerCase();
    const filtered = categories.filter((cate) =>
      cate.name.toLowerCase().includes(searchValue)
    );
    setFilteredProdctCat(filtered);
  };
  const handleSearchProduct = () => {
    const searchValue = searchTermProduct.toLowerCase();
    const filtered = products.filter((prod) =>
      prod.produt_name.toLowerCase().includes(searchValue)
    );
    setFilteredProdct(filtered);
  };
  const handleProductClick = async (product) => {
    setLoading(true);
    setSelectedCategory(null);
    setSelectedProduct(product);
    try {
      const res = await axiosData.get(`getProductDetails/${product._id}`);
      setLoading(false);
    } catch (err) {
      console.error("Failed to fetch products", err);
      setLoading(false);
    }
  };
  const handleSearchAll = async (category) => {
    setLoading(true);
    setSelectedIdea(null);
    setSelectedProduct(null);
    if (category.name === "Registration Ideas") {
      try {
        const res = await axiosData.get(`getIdeasByCategory/${category._id}`);
        setIdeas(res.data.ideas);
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch ideas", err);
        setLoading(false);
      }
    } else {
      try {
        const res = await axiosData.get(`getAllProductDel`);
        setProducts(res.data.productDetails);
        setSelectedCategory(category);
        //setFilteredProdct(res.data.productDetails);
        const filteredpro = res.data.productDetails.filter((prod) =>
          prod.produt_name.toLowerCase().includes(searchTerm)
        );
        setFilteredProdct(filteredpro); // ? show only matched products
        setSearchTermProduct(searchTerm);
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch products", err);
        setLoading(false);
      }
    }
  };
  const handleCategoryClick = async (category) => {
    setLoading(true);
    setSelectedCategory(category);
    setSelectedIdea(null);
    setSelectedProduct(null);
    if (category.name === "Registration Ideas") {
      try {
        const res = await axiosData.get(`getIdeasByCategory/${category._id}`);
        setIdeas(res.data.ideas);
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch ideas", err);
        setLoading(false);
      }
    } else {
      try {
        const res = await axiosData.get(`getProductDetails/${category?._id}`);
        setProducts(res.data.productDetails);
        setFilteredProdct(res.data.productDetails);
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch products", err);
        setLoading(false);
      }
    }
  };
  const fetchUser = async (email) => {
    try {
      const response = await axiosData.get(`getUser/${email}`);
      if (response.data) {
        setUserDetails(response.data.user);
        setSelectedCity(response.data.user?.city || "chennai");
        setLoading(false);
      }
    } catch (err) {
      console.error("User get error", err);
      setLoading(false);
    }
  };
useEffect(() => {
  const handler = setTimeout(() => {
    setDebouncedSearch(searchTerm);
  }, 500); // <- wait 500ms after typing stops

  return () => clearTimeout(handler);
}, [searchTerm]);

useEffect(() => {
  if (debouncedSearch.length >= 3) {
    // Start searching only after 3 letters
    handleSearchAll("all"); // Or your logic here
  } else if (debouncedSearch.length === 0) {
    setFilteredProdctCat(categories); // Reset on clear
  }
}, [debouncedSearch]);
  // 1?? Fetch only once
  useEffect(() => {
    // Fetch only if we don't already have categories
    if (!categories || categories.length === 0) {
      setLoading(true);
      const storedAuth = localStorage.getItem("auth");
      const parsed = JSON.parse(storedAuth);
      fetchUser(parsed?.email);
      fetchCategory(); // Make sure fetchCategory updates categories state once
    }
  }, []); // run only on mount

  useEffect(() => {
    // Run only after categories are available
    if (selectedCategoryGet) {
      const dataCat = categories.filter((data) => data._id === selectedCategoryGet);
      if (dataCat) {
        setSearchTerm("")
        setSearchTermProduct("")
        handleCategoryClick(dataCat[0])
      }
    }
  }, [selectedCategoryGet]); // run only when these change

  const fetchCategory = async () => {
    await axiosData
      .get(`getAllProductCategory`)
      .then((data) => {
        setCategories(data.data.productCAtegory);
        setFilteredProdctCat(data.data.productCAtegory);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error", error);
      });
  };

  const fetchIdeas = async (id) => {
    setLoading(true);
    await axiosData
      .get(`getIdeasByCategory/${id}`)
      .then((data) => {
        setIdeas(data.data.ideas);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error", error);
        setLoading(false);
      });
  };

  const handleAddCategory = async () => {
    if (newCategory.trim()) {
      try {
        const randomColor = colors[Math.floor(Math.random() * colors.length)];
        const response = await axiosData.post("registerProductCat", {
          name: newCategory,
          productList: [],
        });
        if (response.data) {
          fetchCategory();
          setCategories((prev) => [...prev, response.data.newCategory]);
          setFilteredProdctCat((prev) => [...prev, response.data.newCategory]);
          setNewCategory("");
        }
      } catch (err) {
        console.error("Error adding category", err);
      }
    }
  };

  const handleAddIdea = async () => {
    if (newIdea.trim()) {
      try {
        const response = await axiosData.post("createIdea", {
          name: newIdea,
          categoryId: selectedCategory._id,
          productList: [],
        });
        if (response.data) {
          fetchIdeas(selectedCategory._id);
          setNewIdea("");
        }
      } catch (err) {
        console.error("Error adding category", err);
      }
    }
  };

  const handleDeleteCategory = (_id) => {
    setCategories(categories.filter((category) => category._id !== _id));
    setFilteredProdctCat(categories.filter((category) => category._id !== _id));
  };
  // useEffect(() => {
  //   window.history.pushState(null, "", window.location.href);
  //   const handlePopState = () => {
  //     if (selectedCategory) {
  //       setSelectedCategory(null);
  //     } else {
  //       window.history.back();
  //     }
  //   };
  //   window.addEventListener("popstate", handlePopState);
  //   return () => window.removeEventListener("popstate", handlePopState);
  // }, [selectedCategory]);
  useEffect(() => {
    const handlePopState = () => {
      if (selectedProduct) {
        // ?? Step 1: Product Details ? Product List
        setSelectedProduct(null);
      } else if (selectedCategory) {
        // ?? Step 2: Product List ? Categories
        setSelectedCategory(null);
      } else {
        // ?? Step 3: Categories ? exit (real back)
        window.removeEventListener("popstate", handlePopState);
        window.history.back();
      }
    };

    // ?? Only push a dummy state once when entering this view
    if (!selectedCategory && !selectedProduct) {
      window.history.pushState(null, "", window.location.href);
    }

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [selectedCategory, selectedProduct]);
  const getRandomGradient = () => {
    return gradientColors[Math.floor(Math.random() * gradientColors.length)];
  };
  // if (!loading)
  //   return (
  //     <Box
  //       sx={{
  //         minHeight: "100vh",
  //         p: { xs: 2, md: 4 },
  //         bgcolor: "background.default",
  //         borderRadius: "20px",

  //       }}
  //     >
  //       <ModernLoader  variant="wave" size={80} primaryColor="#ab0606ff" text="Loading" />
  //     </Box>
  //   );
  if (loading) {
    if (selectedProduct) {
      return (
        <Box
          sx={{
            minHeight: "100vh",
            p: { xs: 2, md: 4 },
            bgcolor: "background.default",
            borderRadius: "20px",
          }}
        >
          <ProductCategoriesLoader />
        </Box>
      );
    } else if (selectedCategory) {
      if (selectedCategory.name === "Registration Ideas" && !selectedIdea) {
        return <RegistrationIdeasLoader />;
      } else {
        return (
          <Box
            sx={{
              minHeight: "100vh",
              p: { xs: 2, md: 4 },
              bgcolor: "background.default",
              borderRadius: "20px",
            }}
          >
            <CategoryDetailsLoader />
          </Box>
        );
      }
    } else {
      return (
        <Box
          sx={{
            minHeight: "100vh",
            p: { xs: 2, md: 4 },
            bgcolor: "background.default",
            borderRadius: "20px",
          }}
        >
          {" "}
          <ProductCategoriesLoader />
        </Box>
      ); // or <ModernLoader />
    }
  }
  return (
    <Box
      sx={{
        //minHeight: "100vh",
        p: { xs: 2, md: selectedProduct ? 0 : 1 },
        bgcolor: "background.default",
        borderRadius: "20px",
      }}
    >
      {selectedProduct ? (
        <ProductDetailView
          product={selectedProduct}
          onBack={() => setSelectedProduct(null)}
        />
      ) : selectedCategory ? (
        <Box>
          {/* Back Button */}
          <Slide direction="right" in={true}>
            {/* <Button
              startIcon={<ArrowBack />}
              onClick={() => {
                if (selectedProduct) {
                  setSelectedProduct(null);
                } else if (selectedIdea) {
                  setSelectedIdea(null);
                } else {
                  setSelectedCategory(null);
                }
              }}
              sx={{
                color: "text.primary",
                mb: 2,
                "&:hover": {
                  backgroundColor: "action.hover",
                  transform: "translateX(-4px)",
                  transition: "transform 0.3s",
                },
              }}
            >
              Back
            </Button> */}

            <Button
              startIcon={<ArrowBack sx={{ transition: "transform 0.2s" }} />}
              onClick={() => {
                if (selectedProduct) {
                  setSelectedProduct(null);
                } else if (selectedIdea) {
                  setSelectedIdea(null);
                } else {
                  setSelectedCategory(null);
                }
              }}
              sx={{
                color: "text.primary",
                mb: 1,
                borderRadius: "12px",
                backgroundColor: "background.paper",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                transition: "all 0.3s ease",
                border: "1.5px solid", // Thicker border
                borderColor: "#d32f2f", // Red border color
                "&:hover": {
                  backgroundColor: "action.hover",
                  transform: "translateX(-4px)",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  borderColor: "#d32f2f", // Keep red on hover
                  "& .MuiSvgIcon-root": {
                    transform: "translateX(-2px)",
                  },
                },
                "&:active": {
                  transform: "translateX(-2px) scale(0.98)",
                },
              }}
              variant="outlined"
            >
              Back
            </Button>
          </Slide>

          {/* Heading */}
          <Box
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            justifyContent={{ xs: "center", sm: "center", md: "center" }}
            alignItems={{ xs: "center", sm: "center", md: "center" }}
            //mb={3}
            gap={{ xs: 2, sm: 4, md: 4, lg: 30 }}
          >
            <Box display="flex" alignItems={"center"}>
              <Fade in={true} timeout={500}>
                <Typography
                  variant="h4"
                  gutterBottom
                  fullWidth
                  mr={{ xs: 0, sm: 0, md: 4 }}
                  sx={{
                    fontWeight: 800,
                    color: "text.primary",
                    textAlign: "center",
                    //mr: 4,
                    position: "relative",
                    "&:after": {
                      content: '""',
                      display: "block",
                      width: "80px",
                      height: "4px",
                      background: getRandomGradient(),
                      margin: "10px auto 0",
                      borderRadius: "2px",
                      animation: `${pulseAnimation} 2s infinite`,
                    },
                    background: getRandomGradient(),
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  {selectedIdea
                    ? `Products in "${selectedIdea.name}"`
                    : selectedCategory.name === "Registration Ideas"
                    ? "Select an Idea"
                    : `${
                        selectedCategory.name ? selectedCategory.name : "All"
                      } Products`}
                </Typography>
              </Fade>
            </Box>
            <Box
              display="flex"
              //fullWidth
              flexDirection={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              textAlign={"center"}
              alignItems={{ xs: "center", sm: "center", md: "center" }}
              mb={3}
              gap={{ xs: 2, sm: 2, md: 2 }}
            >
              <TextField
                size="small"
                placeholder="Search products..."
                value={searchTermProduct}
                onChange={(e) => {
                  setSearchTermProduct(e.target.value);
                  const searchValue = e.target.value.toLowerCase();
                  if (searchValue.length >= 3) {
                    const filtered = products.filter((prod) =>
                      prod.produt_name.toLowerCase().includes(searchValue)
                    );
                    setFilteredProdct(filtered);
                  } else {
                    setFilteredProdct(products);
                  }
                }}
                onKeyPress={(e) => e.key === "Enter" && handleSearchProduct()}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                }}
                mr={{ xs: 0, sm: 0, md: 2 }}
                mb={{ xs: 10, sm: 10, md: 0 }}
                fullWidth
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleSearchProduct}
              >
                Search
              </Button>
            </Box>
          </Box>
          {/* Registration Ideas Section */}
          {selectedCategory.name === "Registration Ideas" && !selectedIdea ? (
            <Box>
              <Grow in={true}>
                <Paper
                  elevation={3}
                  sx={{
                    p: 3,
                    mb: 4,
                    borderRadius: 3,
                    background: "rgba(255,255,255,0.05)",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <Box display="flex" alignItems="center">
                    <TextField
                      fullWidth
                      size="medium"
                      label="New Idea Name"
                      value={newIdea}
                      onChange={(e) => setNewIdea(e.target.value)}
                      sx={{
                        mr: 2,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          background: theme.palette.background.paper,
                        },
                      }}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AddIcon />}
                      onClick={handleAddIdea}
                      sx={{
                        height: "48px",
                        borderRadius: 2,
                        px: 3,
                        fontWeight: 600,
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        "&:hover": {
                          boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
                          transform: "scale(1.02)",
                        },
                      }}
                    >
                      Add Idea
                    </Button>
                  </Box>
                </Paper>
              </Grow>

              <Grid container spacing={3} sx={{ justifyContent: "center" }}>
                {ideas.map((idea, index) => (
                  <Grid item xs={12} sm={6} md={4} key={idea._id}>
                    <Grow in={true} timeout={(index + 1) * 200}>
                      <Card
                        onClick={() => {
                          setSelectedIdea(idea);
                          setProducts(idea.productList || []);
                          setFilteredProdct(idea.productList || []);
                        }}
                        sx={{
                          width: 300, // Fixed width for idea cards
                          height: 200,
                          cursor: "pointer",
                          borderRadius: 3,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
                          background: getRandomGradient(),
                          color: "white",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
                            transform: "translateY(-8px)",
                            animation: `${floatAnimation} 3s ease-in-out infinite`,
                          },
                        }}
                      >
                        <Typography variant="h5" sx={{ fontWeight: 700 }}>
                          {idea.name}
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          {idea.description}
                        </Typography>
                        <Chip
                          label={`${idea.productList?.length || 0} products`}
                          sx={{
                            mt: 2,
                            bgcolor: "rgba(255,255,255,0.2)",
                            color: "white",
                          }}
                        />
                      </Card>
                    </Grow>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ) : (
            // Products Grid with fixed width cards
            <Grid container spacing={3} sx={{ justifyContent: "center" }}>
              {filteredProdct.length > 0 ? (
                filteredProdct.map((product, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={product._id}
                    sx={{
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Zoom in={true} timeout={(index + 1) * 200}>
                      <Card
                        sx={{
                          // width: 320, // Fixed width for product cards
                          // height: 320,
                          width: 290,
                          height: 178,
                          borderRadius: 4,
                          overflow: "hidden",
                          position: "relative",
                          //boxShadow: "0 8px 30px rgba(241, 134, 134, 0.15)",
                          boxShadow: "0 8px 30px rgba(241, 134, 134, 0.15)",
                          backgroundImage: `url(${
                            product?.image_local_url
                              ? `https://api-productcatelog.bilimbe.in/assets/${encodeURIComponent(
                                  product?.image_local_url
                                )}`
                              : "/imagedigitalen.jpeg" // Fallback image
                          })`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundColor: "black",
                          transition:
                            "transform 0.3s ease, box-shadow 0.3s ease",
                          "&:hover": {
                            transform: "translateY(-5px)",
                            boxShadow: "0 12px 35px rgba(0,0,0,0.25)",
                          },
                        }}
                        onClick={() => {
                          setSelectedCategory(null);
                          setSelectedProduct(product)}}
                      >
                        <Box
                          sx={{
                            position: "absolute",
                            inset: 0,
                            background:
                              "linear-gradient(to right, rgba(211, 21, 21, 0.85) 1%, rgba(228, 138, 138, 0.3) 50%, transparent 100%)",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            color: "white",
                            px: 4,
                          }}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 800,
                              mb: 2,
                              lineHeight: 1.3,
                              fontSize: { xs: "1.1rem", sm: "1.50rem" },
                            }}
                          >
                            {product?.produt_name}
                          </Typography>
                          {/* <Typography
  variant="body2"
  sx={{ 
    fontWeight: 500, 
    mb: 0.5,
    opacity: 0.9,
    fontSize: '0.9rem'
  }}
>
  {product?.productCategory || selectedCategory?.name}
</Typography> */}
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "white",
                              color: "#0b1a33",
                              textTransform: "none",
                              fontWeight: 500,
                              borderRadius: 10,
                              width: "fit-content",
                              px: 3,
                              py: 0.8,
                              boxShadow: "0 3px 12px rgba(255,255,255,0.3)",
                              "&:hover": {
                                backgroundColor: "#f3f3f3",
                              },
                            }}
                          >
                            View Details
                          </Button>
                        </Box>
                        {/* <CardContent
                          sx={{
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                            height: "calc(100% - 180px)",
                          }}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 700,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              textAlign: "center",
                            }}
                          >
                            {product?.produt_name}
                          </Typography>
                          <CardActions sx={{ p: 0, mt: "auto" }}>
                            <Button
                              fullWidth
                              variant="contained"
                              size="medium"
                              onClick={() => setSelectedProduct(product)}
                              sx={{
                                fontWeight: 600,
                                borderRadius: 2,
                                textTransform: "none",
                                background: getRandomGradient(),
                                "&:hover": {
                                  transform: "scale(1.02)",
                                },
                              }}
                            >
                              View Details
                            </Button>
                          </CardActions>
                        </CardContent> */}
                      </Card>
                    </Zoom>
                  </Grid>
                ))
              ) : (
                <Fade in={true}>
                  <Box sx={{ textAlign: "center" }}>
                    <Typography
                      variant="h6"
                      sx={{
                        textAlign: "center",
                        p: 4,
                        color: "text.secondary",
                      }}
                    >
                      No products found in this category.
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{
                        textAlign: "center",
                      }}
                      onClick={() => {
                        setFilteredProdct(products);
                        setSearchTermProduct("");
                      }}
                    >
                      Go Back
                    </Button>
                  </Box>
                </Fade>
              )}
            </Grid>
          )}
        </Box>
      ) : (
        // Main Categories View with fixed width cards
        <Box>
          <Box
            display="flex"
            fullWidth
            flexDirection={{ xs: "column", sm: "row" }}
            justifyContent={{ xs: "center", sm: "center", md: "center" }}
            alignItems={{ xs: "center", sm: "center", md: "center" }}
            //mb={3}
            gap={{ xs: 2, sm: 4, md: 4, lg: 30 }}
          >
            <Box display="flex" alignItems={"center"}>
              <Fade in={true}>
                <Typography
                  variant="h4"
                  gutterBottom
                  sx={{
                    fontWeight: 800,
                    mr: 4,
                    textAlign: "center",
                    position: "relative",
                    color: "text.primary",
                    "&:after": {
                      content: '""',
                      display: "block",
                      width: "80px",
                      height: "4px",
                      background: getRandomGradient(),
                      margin: "16px auto 0",
                      borderRadius: "2px",
                    },
                    background: getRandomGradient(),
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  Product Categories
                </Typography>
              </Fade>
            </Box>
            <Box
              display="flex"
              fullWidth
              flexDirection={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              textAlign={"center"}
              alignItems={{ xs: "center", sm: "center", md: "center" }}
              mb={3}
              gap={{ xs: 2, sm: 2, md: 2 }}
            >
              <TextField
                size="small"
                placeholder="Search categories..."
                value={searchTerm}
                // onChange={(e) => {
                //   const value = e.target.value.toLowerCase();
                //   setSearchTerm(value);
                //   // Only search if >= 3 characters
                //   // Search categories
                //   // const filteredCategories = categories.filter((cate) =>
                //   //   cate.name.toLowerCase().includes(value)
                //   // );
                //   // setFilteredProdctCat(filteredCategories);
                //   setTimeout(() => {
                //     if (value.length >= 2) {
                //       let foundCategory = null;
                //       let matchedProducts = [];
                //       // Search products
                //       categories.forEach((cat) => {
                //         const filteredProducts = cat.productList.filter(
                //           (prod) => prod.toLowerCase().includes(value)
                //         );
                //         if (filteredProducts.length > 0) {
                //           foundCategory = cat;
                //           matchedProducts = filteredProducts;
                //         }
                //       });
                //       if (foundCategory) {
                //         handleSearchAll("all");
                //       }
                //     }
                //   }, 2000);
                // }}
                onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
                onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                }}
                mr={{ xs: 0, sm: 0, md: 2 }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleSearch}
              >
                Search
              </Button>
            </Box>
            {/* <Slide direction="left" in={true}>
              <Paper
                sx={{
                  p: 2,
                  borderRadius: 3,
                  background: "rgba(255,255,255,0.05)",
                  backdropFilter: "blur(10px)",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                }}
              >
                <Box display="flex" alignItems="center">
                  <TextField
                    fullWidth
                    size="medium"
                    label="New Category Name"
                    value={newCategory}
                    onChange={(e) => setNewCategory(e.target.value)}
                    sx={{
                      mr: 2,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        background: theme.palette.background.paper,
                      },
                    }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={handleAddCategory}
                    sx={{
                      height: "48px",
                      borderRadius: 2,
                      px: 3,
                      fontWeight: 600,
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      "&:hover": {
                        boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
                        transform: "scale(1.03)",
                      },
                    }}
                  >
                    Add
                  </Button>
                </Box>
              </Paper>
            </Slide> */}
          </Box>

          <Grid container spacing={3} sx={{ justifyContent: "center" }}>
            {filteredProdctCat.length > 0 ? (
              filteredProdctCat.map((category, index) => {
                const city =
                  selectedCity?.charAt(0).toUpperCase() +
                  selectedCity?.slice(1);
                const isCategoryOff =
                  category?.status?.[city]?.toLowerCase() === "off";
                return (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    key={category?._id}
                    sx={{
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Grow in={true} timeout={(index + 1) * 200}>
                      {/* <Card
                      onClick={() => handleCategoryClick(category)}
                      sx={{
                        width: 290, // Fixed width for category cards
                        height: "200px",
                        display: "flex",
                        flexDirection: "column",
                        borderRadius: 3,
                        boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                        transition: "all 0.3s ease",
                        background: getRandomGradient(),
                        color: "white",
                        "&:hover": {
                          transform: "translateY(-8px)",
                          boxShadow: "0 12px 24px rgba(0,0,0,0.2)",
                          animation: `${floatAnimation} 3s ease-in-out infinite`,
                        },
                      }}
                    >
                      <CardContent
                        sx={{
                          flexGrow: 1,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                        }}
                      >
                        <Avatar
                          sx={{
                            bgcolor: "rgba(255,255,255,0.2)",
                            mr: 2,
                            width: 60,
                            height: 60,
                            mb: 2,
                          }}
                        >
                          <CategoryIcon
                            fontSize="large"
                            sx={{ color: "white" }}
                          />
                        </Avatar>
                        <Typography
                          variant="h5"
                          component="div"
                          sx={{ fontWeight: 700, mb: 1 }}
                        >
                          {category?.name}
                        </Typography>
                        <Chip
                          label={`${
                            category?.productList?.length === undefined
                              ? 0
                              : category?.productList?.length
                          } products`}
                          sx={{
                            fontSize: "0.9rem",
                            px: 2,
                            py: 1,
                            background: "rgba(255,255,255,0.2)",
                            color: "white",
                          }}
                        />
                      </CardContent>
                    </Card> */}
                      {/* <Card
  onClick={() => handleCategoryClick(category)}
  sx={{
    width: 290,
    height: 180,
    borderRadius: 5,
    overflow: "hidden",
    position: "relative",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    cursor: "pointer",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    backgroundImage: `url(${
      category?.image ||
      "https://images.unsplash.com/photo-1549880338-65ddcdfd017b?w=800"
    })`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    "&:hover": {
      transform: "translateY(-6px)",
      boxShadow: "0 15px 40px rgba(0,0,0,0.3)",
    },
  }}
>
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      background:
        "linear-gradient(to right, rgba(0,0,0,1), rgba(0,0,0,0))",
      zIndex: 1,
      width:"100%"
    }}
  />
  <Box
    sx={{
      position: "relative",
      zIndex: 2,
      color: "white",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      height: "100%",
      p: 3,
    }}
  >
    <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
      {category?.name}
    </Typography>

    <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
      {category?.productList?.length || 0}
      <Typography
        component="span"
        sx={{ fontSize: 14, opacity: 0.7, ml: 0.5 }}
      >
        products
      </Typography>
    </Typography>

    <Button
      variant="contained"
      sx={{
        borderRadius: 10,
        backgroundColor: "white",
        color: "black",
        textTransform: "none",
        fontWeight: 500,
        px: 2.5,
        py: 0.7,
        width: "fit-content",
        boxShadow: "0 2px 10px rgba(255,255,255,0.3)",
        "&:hover": { backgroundColor: "#f3f3f3" },
      }}
    >
      Explore Now
    </Button>
  </Box>
</Card> */}
                      <Tooltip
                        title="Click here to start exploring other cities"
                        followCursor
                        arrow
                         disableHoverListener={!isCategoryOff} 
                      >
                        <Box
                          sx={{ position: "relative", width: "290px" }}
                          onClick={() => handleCategoryClick(category)}
                        >
                          {isCategoryOff && (
                            <Typography
                              sx={{
                                position: "absolute",
                                top: 70,
                                left: "50%",
                                transform: "translateX(-50%)",
                                backgroundColor: "#fff",
                                color: "#d32f2f",
                                px: 2,
                                py: 0.5,
                                fontSize: "0.75rem",
                                fontWeight: 700,
                                borderRadius: "8px",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                zIndex: 5,
                                width: "max-content",
                                display:"flex",
                                gap:"5px"
                              }}
                            >
                               <BlockIcon sx={{ fontSize: "15px",color:"#d32f2f" }} /> Unavailable in {selectedCity}
                            </Typography>
                          )}
                          {/* <Paper
    elevation={3}
    sx={{
      borderRadius: 3,
      p: 2,
      opacity: isCategoryOff  ? 0.5 : 1,
      filter: isCategoryOff  ? "grayscale(1) brightness(0.7)" : "none",
      pointerEvents: isCategoryOff  ? "none" : "auto",
      transition: "0.3s",
    }}
  > */}
                          <Card
                            sx={{
                              width: 290,
                              height: 178,
                              borderRadius: 4,
                              overflow: "hidden",
                              position: "relative",
                              boxShadow: "0 8px 30px rgba(241, 134, 134, 0.15)",
                              backgroundImage: `url(${
                                category.name === "Video Booth"
                                  ? "/imagevideo.jpeg"
                                  : category.name === "Touch Screen"
                                  ? "/touch-screen.webp"
                                  : category.name === "Interactive Games"
                                  ? "/imageinteractive.jpeg"
                                  : category.name === "VR Games"
                                  ? "vr-games.webp"
                                  : category.name === "Photo Booth"
                                  ? "/photobooth2.webp"
                                  : category.name === "AR Games"
                                  ? "/AR-Games.jpg"
                                  : "/imagedigitalen.jpeg"
                              })`,
                              backgroundSize: "cover",
                              backgroundPosition: "right",
                              backgroundRepeat: "no-repeat",
                              backgroundColor: "black",
                              opacity: isCategoryOff ? 0.5 : 1,
                              filter: isCategoryOff
                                ? "grayscale(1) brightness(0.7)"
                                : "none",
                              pointerEvents: isCategoryOff ? "none" : "auto",
                              transition:
                                "transform 0.3s ease, box-shadow 0.3s ease",
                              "&:hover": {
                                transform: "translateY(-5px)",
                                boxShadow: "0 12px 35px rgba(0,0,0,0.25)",
                              },
                            }}
                            onClick={() => handleCategoryClick(category)}
                          >
                            <Box
                              sx={{
                                position: "absolute",
                                inset: 0,
                                background:
                                  "linear-gradient(to right, rgba(211, 21, 21, 0.85) 40%, rgba(228, 138, 138, 0.3) 70%, transparent 100%)",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                color: "white",
                                px: 4,
                              }}
                            >
                              <Typography
                                variant="h5"
                                sx={{
                                  fontWeight: 800,
                                  mb: 0.5,
                                  lineHeight: 1.3,
                                }}
                              >
                                {category?.name}
                              </Typography>

                              <Typography
                                variant="h6"
                                sx={{ fontWeight: 600, mb: 1 }}
                              >
                                {category?.productList?.length === undefined
                                  ? 0
                                  : category?.productList?.length}
                                <Typography
                                  component="span"
                                  sx={{ fontSize: "1rem", opacity: 0.8 }}
                                >
                                  {" products"}
                                </Typography>
                              </Typography>

                              <Button
                                variant="contained"
                                sx={{
                                  backgroundColor: "white",
                                  color: "#0b1a33",
                                  textTransform: "none",
                                  fontWeight: 500,
                                  borderRadius: 10,
                                  width: "fit-content",
                                  px: 3,
                                  py: 0.8,
                                  boxShadow: "0 3px 12px rgba(255,255,255,0.3)",
                                  "&:hover": {
                                    backgroundColor: "#f3f3f3",
                                  },
                                }}
                              >
                                {"Explore Now"}
                              </Button>
                            </Box>
                          </Card>
                          {/* </Paper> */}
                        </Box>
                      </Tooltip>
                    </Grow>
                  </Grid>
                );
              })
            ) : (
              <Fade in={true}>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    variant="h6"
                    sx={{
                      textAlign: "center",
                      p: 4,
                      color: "text.secondary",
                    }}
                  >
                    No products found in this input.
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{
                      textAlign: "center",
                    }}
                    onClick={() => {
                      setFilteredProdctCat(categories);
                      setSearchTerm("");
                    }}
                  >
                    Go Back
                  </Button>
                </Box>
              </Fade>
            )}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default ProductCategories;
